module.exports = __webpack_public_path__ + "img/Canada1.0a755734.jpg";